import { UserRole } from './User';
import { QuestionType } from './Question';

export interface ResultSchema {
    id: string; //uid
    userId: string; //the userId of the User answering this Question
    questionId: string; //the questionId of the specific Question this is answering
    timestamp: string; //simplified extended ISO format: YYYY-MM-DDTHH:mm:ss.sssZ
    answer: string | Importance; //the User's answer; this is either the importance rating they've given OR the free-text answer (for the sole Phase 1 "Other" question)
    topPriority: boolean; //flag if user marked this Question a top priority
}

export enum Importance {
    NOT_IMPORTANT = 1,
    IMPORTANT,
    VERY_IMPORTANT,
}

export interface CreateResultRequest {
    questionId: string;
    answer: Importance | string;
}

export interface UpdateResultRequest {
    questionId: string;
    answer?: Importance | string;
    topPriority?: boolean;
}

export interface ViewResultResponse {
    topPriority: PairResult[];
    nonRankedQuestions: PairResult[];
    rankedQuestions: StackRankedImportance;
}
export type StackRankedImportance = {
    [key in Importance]: {
        [key in Importance]: PairResult[]
    };
}

export interface PairResult {
    id: string;
    text: { [key in UserRole]?: string };
    answer: { [key in UserRole]?: string | Importance };
    questionType: QuestionType;
}

export interface EmailResultRequest {
    email: string;
}

// each key is a userId, and the value is an array of that user's survey completion timestamps (in order by date, most recent first)
export interface CompletionDates {
    [key: string]: {
        completionDates: string[];
        lastDownloadDate: string | null;
        topPriCompleted: boolean;
    }
}

